import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  Alert,
  CircularProgress,
  Stack,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tabs, // Para Abas
  Tab,  // Para Abas
  TableContainer, // Para Tabela Aditivos
  Table,          // Para Tabela Aditivos
  TableHead,      // Para Tabela Aditivos
  TableRow,       // Para Tabela Aditivos
  TableCell,      // Para Tabela Aditivos
  TableBody,      // Para Tabela Aditivos
  Paper,          // Para Tabela Aditivos
  IconButton,     // Para Botões Tabela (Opcional: Editar/Excluir)
  Drawer,         // Para Modal Lateral
  Autocomplete,   // Para Motivo Multiselect
  Checkbox,       // Para Autocomplete
  FormHelperText, // Para Info no campo Valor
  TablePagination, // Adicionado para paginação
  Tooltip,
  FormControlLabel,
  Switch,
  Chip, // <<< Adicionar Chip
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Snackbar
} from '@mui/material';
import { 
  Save, ArrowLeft, PlusCircle, Edit, Trash2, RotateCcw, Eye, X, 
  FileText, HardDrive, FilePlus, PauseCircle, FileX, Undo2 
} from 'lucide-react';
import { 
  ContractFormData, 
  AditivoContratual, 
  EquipamentoAlocado, 
  SuspensaoContrato, 
  ContractPaymentType, // Mover para cá
  ContractAdditiveMotive, // Mover para cá
  ContractOperationSuspended, // Mover para cá
  ContractReasonTermination // Mover para cá
} from '../../types/contract'; // Importar AditivoContratual, EquipamentoAlocado, SuspensaoContrato E OS TIPOS
import { Company } from '../../types/company'; // Para Select Empresa
import { Person } from '../../types/person'; // Para Select Pessoa
import { Equipment } from '../../types/equipment'; // Importar Equipment
import { useTheme } from '@mui/material/styles';
import ConfirmationDialog from '../../components/common/ConfirmationDialog'; // <<< Adicionar Import
import SuccessSnackbar from '../../components/common/SuccessSnackbar'; // <<< Adicionar Import
import { formatDateToBR } from '../../utils/dateUtils';

// Importar Serviços com Named Import
import { CompanyService } from '../../services/companyService'; // Mantém named
import { PersonService } from '../../services/personService'; // Mantém named
import EquipmentService from '../../services/equipmentService'; // <<< CORREÇÃO: Volta para default import
import ContractService from '../../services/contractService'; // Importar APENAS o serviço default

// Comentar ou remover Mock data
/*
const mockCompanies: Company[] = [...];
const mockPersons: Person[] = [...];
const mockEquipments: Equipment[] = [...];
*/

// Manter tiposSuspensao por enquanto, até buscarmos da API
// const tiposSuspensao: TipoSuspensao[] = ['Vendeu', 'Descansou'];

// Interface para o painel das abas
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`contract-tabpanel-${index}`}
      aria-labelledby={`contract-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 2, pb: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `contract-tab-${index}`,
    'aria-controls': `contract-tabpanel-${index}`,
  };
}

const ContractFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Determinar modos corretamente
  const isViewMode = Boolean(id && location.pathname.includes('/view/'));
  const isEditMode = Boolean(id && !isViewMode);
  const isAdmin = true; // Simulação: normalmente isso viria de um hook de autenticação

  const [currentTab, setCurrentTab] = useState(0);

  const [contract, setContract] = useState<ContractFormData>({
    company_id: undefined,
    person_id: undefined,
    contract_start_date: '',
    contract_payment_type_id: undefined,
    value: undefined,
    observation_start: '',
    contractAdditives: [], // Garantir que a propriedade correta é usada aqui
    contract_equipments: [], // Manter como estava por enquanto
    suspensao: [],
    contract_reason_termination_id: undefined,
    termination_date: '',
    termination_observations: '',
    termination_user_id: undefined,
    termination_datetime: undefined,
    active: true,
  });

  // Estados para o Drawer de Aditivo
  const [isAditivoDrawerOpen, setIsAditivoDrawerOpen] = useState(false);
  const [currentAditivo, setCurrentAditivo] = useState<Partial<AditivoContratual & { selectedMotivoIds: number[] }>>({
    additive_date: '',
    contract_payment_type_id: undefined,
    value: undefined,
    selectedMotivoIds: [],
    observations: ''
  });
  const [aditivoError, setAditivoError] = useState<string | null>(null);

  // Estados para Paginação da Tabela de Aditivos
  const [aditivosPage, setAditivosPage] = useState(0);
  const [aditivosRowsPerPage, setAditivosRowsPerPage] = useState(5); // Ou 10

  // State for Equipment Association Drawer
  const [isAssociateDrawerOpen, setIsAssociateDrawerOpen] = useState(false);
  const [currentAssociation, setCurrentAssociation] = useState<Partial<EquipamentoAlocado>>({ equipment_id: undefined, delivery_date: '' });
  const [associationError, setAssociationError] = useState<string | null>(null);

  // State for Equipment Return Drawer
  const [isReturnDrawerOpen, setIsReturnDrawerOpen] = useState(false);
  const [equipmentToReturn, setEquipmentToReturn] = useState<EquipamentoAlocado | null>(null);
  const [returnDateInDrawer, setReturnDateInDrawer] = useState<string>(''); // <<< GARANTIR QUE ESTA LINHA EXISTA E ESTEJA CORRETA
  const [returnError, setReturnError] = useState<string | null>(null);

  // State for Equipment Table Pagination
  const [equipmentsPage, setEquipmentsPage] = useState(0);
  const [equipmentsRowsPerPage, setEquipmentsRowsPerPage] = useState(5);

  // Suspensão
  const [isSuspensionDrawerOpen, setIsSuspensionDrawerOpen] = useState(false);
  const [currentSuspension, setCurrentSuspension] = useState<Partial<SuspensaoContrato>>({ data: '', qtdDiasUteis: undefined, contract_operation_suspended_id: undefined, observacoes: '' });
  const [suspensionError, setSuspensionError] = useState<string | null>(null);
  const [suspensionsPage, setSuspensionsPage] = useState(0);
  const [suspensionsRowsPerPage, setSuspensionsRowsPerPage] = useState(5);

  // Estados temporários para display dos valores monetários
  const [valorDisplay, setValorDisplay] = useState<string>('');
  const [aditivoValorDisplay, setAditivoValorDisplay] = useState<string>('');

  const [companies, setCompanies] = useState<Company[]>([]);
  const [persons, setPersons] = useState<Person[]>([]);
  const [availableEquipments, setAvailableEquipments] = useState<Equipment[]>([]); // Lista de equipamentos disponíveis
  const [paymentTypes, setPaymentTypes] = useState<ContractPaymentType[]>([]); // <<< NOVO ESTADO
  const [additiveMotives, setAdditiveMotives] = useState<ContractAdditiveMotive[]>([]); // <<< NOVO ESTADO
  const [operationSuspendedOptions, setOperationSuspendedOptions] = useState<ContractOperationSuspended[]>([]); // <<< NOVO ESTADO
  const [reasonTerminationOptions, setReasonTerminationOptions] = useState<ContractReasonTermination[]>([]); // <<< NOVO ESTADO

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false); // <<< NOVO ESTADO
  // Estados para o Snackbar de sucesso
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');
  // Adicionar estados para Snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const theme = useTheme();

  // Instanciar serviços
  const companyService = useMemo(() => new CompanyService(), []);
  const personService = useMemo(() => new PersonService(), []);
  const equipmentService = useMemo(() => new EquipmentService(), []);
  const contractService = ContractService; // <<< CORREÇÃO: Usar a instância importada diretamente

  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      setError(null);
      try {
        const [companyResponse, personResponse, equipmentResponse, paymentTypeResponse, additiveMotiveResponse, operationSuspendedResponse, reasonTerminationResponse] = await Promise.all([
          companyService.getAll({ active: true, pageSize: 500 }), 
          personService.getAll({ active: true, service_provider: true, pageSize: 500 }), 
          equipmentService.getAll({ /* status: 'available' */ }),
          contractService.getAllPaymentTypes(),
          contractService.getAllAdditiveMotives(),
          contractService.getAllOperationSuspended(),
          contractService.getAllReasonTerminations()
        ]);

        setCompanies(companyResponse.data || []);
        setPersons(personResponse.data || []);
        setAvailableEquipments(equipmentResponse.data || []);
        setPaymentTypes(paymentTypeResponse || []);
        setAdditiveMotives(additiveMotiveResponse || []);
        setOperationSuspendedOptions(operationSuspendedResponse || []);
        setReasonTerminationOptions(reasonTerminationResponse || []);
        
        if (id) {
          console.log("Buscando dados do contrato:", id);
          const contractData = await contractService.getById(parseInt(id));
          // console.log("Dados recebidos da API (getById):", contractData); // Log 1 - Modificado para logar direto
          console.log("[LOG 1] Valor bruto da API (contractData.value):", contractData?.value); // <<< LOG 1
          // Adicionar log específico para contract_equipments ANTES do mapeamento
          console.log("API Response - contract_equipments:", contractData?.contract_equipments);

          // <<< GARANTIR QUE O VALOR SEJA NÚMERO AQUI >>>
          const rawValueFromAPI = contractData.value;
          const numericValueFromAPI = typeof rawValueFromAPI === 'string' 
                                      ? parseFloat(rawValueFromAPI) 
                                      : rawValueFromAPI;

          const mappedData: ContractFormData = {
            ...contractData,
            company_id: contractData.company_id ?? undefined,
            person_id: contractData.person_id ?? undefined,
            contract_payment_type_id: contractData.contract_payment_type_id ?? undefined,
            contract_start_date: contractData.contract_start_date ? new Date(contractData.contract_start_date).toISOString().split('T')[0] : '',
            value: numericValueFromAPI ?? undefined, // <<< Usar valor numérico
            observation_start: contractData.observation_start || '',
            active: contractData.active ?? true,
            contractAdditives: contractData.contractAdditives || [],
            contract_equipments: contractData.contract_equipments || [], // << CORREÇÃO AQUI
            suspensao: contractData.suspensao || [], 
            contract_reason_termination_id: contractData.contract_reason_termination_id ?? undefined,
            termination_date: contractData.contract_termination_date ? new Date(contractData.contract_termination_date).toISOString().split('T')[0] : '', 
            termination_observations: contractData.observation_termination || '', 
          };
          console.log("[LOG 2] Valor mapeado para estado (mappedData.value):", mappedData.value); // <<< LOG 2

          // console.log("Dados mapeados para setContract:", mappedData);
          // Adicionar log específico para contract_equipments DEPOIS do mapeamento
          console.log("Mapped Data - contract_equipments:", mappedData?.contract_equipments);
          setContract(mappedData);
          // setValorDisplay(formatCurrency(mappedData.value)); // <<< COMENTAR ESTA LINHA TEMPORARIAMENTE
          console.log("[LOG 3] Estado 'contract' definido. O useEffect [contract.value] deve ser acionado agora."); // <<< LOG 3

        } else {
          setContract({
              company_id: undefined,
              person_id: undefined,
              contract_start_date: '',
              contract_payment_type_id: undefined,
              value: undefined,
              observation_start: '',
              contractAdditives: [], // Garantir propriedade correta
              contract_equipments: [], // Manter como estava
              suspensao: [],
              contract_reason_termination_id: undefined,
              termination_date: '',
              termination_observations: '',
              termination_user_id: undefined,
              termination_datetime: undefined,
              active: true,
          });
          setValorDisplay('');
        }

      } catch (err: any) {
        console.error("Erro ao carregar dados iniciais:", err);
        setError(err.message || 'Falha ao carregar dados iniciais.');
        setCompanies([]);
        setPersons([]);
        setAvailableEquipments([]);
        setPaymentTypes([]); // <<< Limpar em caso de erro
        setAdditiveMotives([]); // Limpar em caso de erro
        setOperationSuspendedOptions([]); // Limpar em caso de erro
        setReasonTerminationOptions([]); // Limpar em caso de erro
      } finally {
        setLoading(false);
      }
    };
    loadInitialData();
  }, [id, companyService, personService, equipmentService, contractService]); // <<< Adicionado contractService

  // Efeito para inicializar/atualizar valorDisplay quando contract.valor mudar
  useEffect(() => {
      // setValorDisplay(formatCurrency(contract.value));
      console.log("[LOG 4] useEffect [contract.value] disparado. contract.value:", contract.value, `(Type: ${typeof contract.value})`); // <<< Log com tipo
      // <<< GARANTIR QUE O VALOR É NÚMERO ANTES DE FORMATAR >>>
      const numericContractValue = typeof contract.value === 'string' 
                                  ? parseFloat(contract.value) 
                                  : contract.value;
      console.log(`[LOG 4.5] useEffect - numericContractValue após parse:`, numericContractValue); // Log parsed value

      const formatted = formatCurrency(numericContractValue); // <<< Passar valor numérico
      console.log("[LOG 5] useEffect [contract.value] - Valor formatado:", formatted);
      setValorDisplay(formatted);
      console.log("[LOG 6] useEffect [contract.value] - valorDisplay definido.");
  }, [contract.value]);

  // Efeito para inicializar/atualizar aditivoValorDisplay quando currentAditivo.valor mudar (ao abrir drawer)
  useEffect(() => {
    if (isAditivoDrawerOpen) {
        setAditivoValorDisplay(formatCurrency(currentAditivo.value));
    }
  }, [currentAditivo.value, isAditivoDrawerOpen]);

  // --- Funções Auxiliares de Formatação/Parse ---
  const formatCurrency = (value: number | undefined | string): string => {
    if (value === undefined || value === null || value === '') return '';
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d,-]/g, '').replace(',', '.')) : value;

    if (isNaN(numericValue)) return '';

    return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const formatCurrencyInput = (value: string): string => {
    const digits = value.replace(/\D/g, '');
    if (!digits) return '';

    const numericValue = parseInt(digits, 10) / 100;

    return numericValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const parseCurrencyValue = (formattedValue: string): number | undefined => {
      const cleaned = formattedValue.replace(/[^\d,]/g, ''); // Manter apenas dígitos e vírgula
      const numericString = cleaned.replace(',', '.');
      const value = parseFloat(numericString);
      return isNaN(value) ? undefined : value;
  };
  // --- Fim Funções Auxiliares ---

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    if (name === 'value') {
      setValorDisplay(formatCurrencyInput(value));
    } else {
      setContract(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = (e: any) => { // SelectChangeEvent
    const { name, value } = e.target;
    setContract(prev => ({ ...prev, [name]: value === '' ? undefined : value }));
  };

  const handleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setContract(prev => ({ ...prev, [name]: checked }));
  };

  // Handlers para o Drawer/Formulário de Aditivo
  const handleOpenAditivoDrawer = () => {
    setCurrentAditivo({ // Resetar form com nomes corretos
      additive_date: '',
      contract_payment_type_id: undefined,
      value: undefined,
      selectedMotivoIds: [],
      observations: ''
    });
    setAditivoValorDisplay(''); 
    setAditivoError(null);
    setIsAditivoDrawerOpen(true);
  };

  const handleCloseAditivoDrawer = () => {
    setIsAditivoDrawerOpen(false);
    setAditivoError(null); // Limpa erros ao fechar
  };

  const handleAditivoInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any) => {
    const target = e.target as HTMLInputElement | HTMLTextAreaElement;
    const { name, value } = target;

    if (name === 'aditivoValor') {
      const formatted = formatCurrencyInput(value);
      setAditivoValorDisplay(formatted);
    } else {
      setCurrentAditivo(prev => ({ 
        ...prev, 
        [name]: target.type === 'select-one' && value === '' ? undefined : value 
      }));
    }
  };

  const handleAditivoSelectChange = (e: any) => { // SelectChangeEvent para Tipo Pagamento Aditivo
    const { name, value } = e.target;
    setCurrentAditivo(prev => ({ ...prev, [name]: value }));
  };

  const handleAditivoMotivoChange = (event: React.SyntheticEvent, newValue: ContractAdditiveMotive[]) => {
    setCurrentAditivo(prev => ({ ...prev, motivo: newValue }));
  };

  const handleAddAditivo = () => {
    // Validação
    const isDataValid = !!currentAditivo.additive_date;
    const isTipoPagamentoValid = !!currentAditivo.contract_payment_type_id;
    const isValorValid = parseCurrencyValue(aditivoValorDisplay) !== undefined; 
    const isMotivoValid = currentAditivo.selectedMotivoIds && currentAditivo.selectedMotivoIds.length > 0;

    if (!isDataValid || !isTipoPagamentoValid || !isValorValid || !isMotivoValid) {
        setAditivoError("Preencha os campos obrigatórios: Data, Tipo Pagamento, Valor e Motivo(s).");
        return;
    }
    setAditivoError(null);

    // Buscar os objetos completos para exibição no grid
    const selectedPaymentTypeObject = paymentTypes.find(
      pt => pt.id === currentAditivo.contract_payment_type_id
    );
    const selectedMotiveObjects = additiveMotives.filter(motive => 
      currentAditivo.selectedMotivoIds?.includes(motive.id)
    );

    // Criar objeto para adicionar ao estado local
    const novoAditivo: any = { // Usar 'any' temporariamente para permitir ID string
      id: `temp-${Date.now()}`, // ID temporário como string
      additive_date: currentAditivo.additive_date as string,
      contract_payment_type_id: currentAditivo.contract_payment_type_id!, // Adicionar '!' para afirmar não-nulo
      value: parseCurrencyValue(aditivoValorDisplay)!, // Usar '!' para afirmar não-nulo após validação
      // contract_additive_motives: currentAditivo.selectedMotivoIds || [], // Não é mais necessário aqui se handleSubmit usa .motives
      observations: currentAditivo.observations || '',
      // Adicionar objetos para renderização do grid:
      motives: selectedMotiveObjects, 
      paymentType: selectedPaymentTypeObject || null,
    };

    setContract(prev => ({
      ...prev,
      contractAdditives: [...(prev.contractAdditives || []), novoAditivo] // Usar propriedade correta e tipo
    }));
    handleCloseAditivoDrawer();
  };

  // Handlers para Paginação da Tabela de Aditivos
  const handleChangeAditivosPage = (event: unknown, newPage: number) => {
    setAditivosPage(newPage);
  };

  const handleChangeAditivosRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAditivosRowsPerPage(parseInt(event.target.value, 10));
    setAditivosPage(0); // Resetar para a primeira página ao mudar linhas por página
  };

  // --- Equipment Association Handlers ---
  const handleOpenAssociateDrawer = () => {
    setCurrentAssociation({ equipment_id: undefined, delivery_date: '' });
    setAssociationError(null);
    setIsAssociateDrawerOpen(true);
  };
  const handleCloseAssociateDrawer = () => setIsAssociateDrawerOpen(false);
  const handleAssociationChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any) => {
    if (e.target && e.target.name) {
        const { name, value } = e.target;
        setCurrentAssociation(prev => ({ ...prev, [name]: value }));
    } else if (typeof e === 'object' && e !== null && !Array.isArray(e)) { 
        const equipmentId = (e as Equipment)?.id;
        setCurrentAssociation(prev => ({ ...prev, equipment_id: equipmentId }));
    }
  };
  const handleAssociateEquipment = () => {
    setAssociationError(null);
    if (!currentAssociation.equipment_id || !currentAssociation.delivery_date) {
      setAssociationError('Selecione um equipamento e informe a data de entrega.');
      return;
    }

    const alreadyAdded = (contract.contract_equipments ?? []).some(
      (eq: EquipamentoAlocado) => eq.equipment_id === Number(currentAssociation.equipment_id) && !eq.return_date // Verifica se já não foi devolvido
    );
    if (alreadyAdded) {
      setAssociationError('Este equipamento já foi adicionado ao contrato.');
      return;
    }

    const equipmentDetails = availableEquipments.find(eq => eq.id === currentAssociation.equipment_id);

    const newAssociation: EquipamentoAlocado = {
      equipment_id: currentAssociation.equipment_id,
      delivery_date: currentAssociation.delivery_date,
      equipment_name: equipmentDetails?.serial_number || 'Série não encontrada', // Corrigido para usar serial_number
      equipment_serial: equipmentDetails?.serial_number || 'Série não encontrada',
      equipment_model: equipmentDetails?.model || undefined, // <<< Adicionar modelo aqui
      return_date: undefined,
      return_motive: undefined
    };

    setContract(prev => ({
      ...prev,
      contract_equipments: [...(prev.contract_equipments || []), newAssociation] // Correção: usar contract_equipments
    }));
    handleCloseAssociateDrawer();
  };

  // --- Equipment Return Handlers ---
  const handleOpenReturnDrawer = (alocacao: EquipamentoAlocado) => {
    setEquipmentToReturn(alocacao);
    setReturnDateInDrawer(alocacao.return_date || '');
    setReturnError(null);
    setIsReturnDrawerOpen(true);
  };
  const handleCloseReturnDrawer = () => {
    setIsReturnDrawerOpen(false);
    setEquipmentToReturn(null); // Limpa o equipamento selecionado
    setReturnError(null);
  };
  const handleReturnFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setReturnDateInDrawer(value);
  };
  const handleReturnEquipment = () => {
    if (!equipmentToReturn) return; // Segurança

    if (!returnDateInDrawer) {
      setReturnError('Informe a data da devolução.');
      return;
    }
    setReturnError(null);

    setContract(prev => ({
      ...prev,
      contract_equipments: (prev.contract_equipments || []).map((aloc: EquipamentoAlocado) => // Correção: usar contract_equipments
        aloc.equipment_id === equipmentToReturn.equipment_id
          ? { ...aloc, return_date: returnDateInDrawer } // Atualiza a data
          : aloc
      )
    }));
    handleCloseReturnDrawer();
  };

  // --- Equipment Pagination Handlers ---
  const handleChangeEquipmentsPage = (event: unknown, newPage: number) => {
    setEquipmentsPage(newPage);
  };
  const handleChangeEquipmentsRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEquipmentsRowsPerPage(parseInt(event.target.value, 10));
    setEquipmentsPage(0);
  };

  // --- Suspension Handlers ---
  const handleOpenSuspensionDrawer = () => {
    setCurrentSuspension({ data: '', qtdDiasUteis: undefined, contract_operation_suspended_id: undefined, observacoes: '' });
    setSuspensionError(null);
    setIsSuspensionDrawerOpen(true);
  };
  const handleCloseSuspensionDrawer = () => setIsSuspensionDrawerOpen(false);

  const handleSuspensionChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setCurrentSuspension(prev => ({
        ...prev,
        [name]: name === 'qtdDiasUteis' ? (value === '' ? undefined : parseInt(value, 10)) : value
    }));
  };

  const handleSuspensionSelectChange = (e: any) => { // Tipar como SelectChangeEvent<any>
    const { name, value } = e.target;
    // Assegurar que o nome do campo é contract_operation_suspended_id
    setCurrentSuspension(prev => ({ ...prev, [name]: value })); 
  };

  const handleAddSuspension = () => {
    // Validação
    const isDataValid = !!currentSuspension.data;
    const isDiasValid = currentSuspension.qtdDiasUteis !== undefined && currentSuspension.qtdDiasUteis > 0;
    const isOperacaoValid = !!currentSuspension.contract_operation_suspended_id; // <<< Validar ID

    if (!isDataValid || !isDiasValid || !isOperacaoValid) {
      setSuspensionError("Preencha os campos obrigatórios: Data, Qtd. Dias e Operação.");
      return;
    }
    setSuspensionError(null);

    // Criar nova suspensão - Usar ID TEMPORÁRIO como string
    const novaSuspensao: any = { // Usar any para permitir ID string temporário
      id: `temp-${Date.now()}`, // <<< ID temporário como STRING
      data: currentSuspension.data as string,
      qtdDiasUteis: Number(currentSuspension.qtdDiasUteis),
      contract_operation_suspended_id: currentSuspension.contract_operation_suspended_id as number, // <<< Usar ID
      observacoes: currentSuspension.observacoes || '',
      createdAt: new Date().toISOString(), // Exemplo
      usuarioCadastro: 'Usuário Mock', // Exemplo
      dataCadastro: new Date().toISOString(), // Exemplo
      // Remover operacao: TipoSuspensao se o tipo foi atualizado
    };

    setContract(prev => ({
      ...prev,
      suspensao: [...(prev.suspensao || []), novaSuspensao]
    }));
    handleCloseSuspensionDrawer();
  };

  // --- Suspension Pagination Handlers ---
  const handleChangeSuspensionsPage = (event: unknown, newPage: number) => {
    setSuspensionsPage(newPage);
  };

  const handleChangeSuspensionsRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSuspensionsRowsPerPage(parseInt(event.target.value, 10));
    setSuspensionsPage(0);
  };

  // --- Handler para Remover Equipamento (Apenas localmente) ---
  const handleRemoveEquipment = (equipmentIdToRemove: number) => {
    setContract(prev => ({
      ...prev,
      contract_equipments: (prev.contract_equipments || []).filter(
        (eq: EquipamentoAlocado) => eq.equipment_id !== equipmentIdToRemove
      )
    }));
  };

  // --- Handler para Remover Suspensão (Apenas localmente) ---
  const handleRemoveSuspension = (suspensionIdToRemove: number | string) => {
    setContract(prev => ({
      ...prev,
      suspensao: (prev.suspensao || []).filter(
        (susp: SuspensaoContrato) => susp.id !== suspensionIdToRemove
      )
    }));
  };

  // --- Handlers para o Drawer de Devolução (MOVER PARA CÁ) ---
  const handleReturnDateInDrawerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('Return Date Input Changed:', event.target.value); // Manter log por enquanto
    setReturnDateInDrawer(event.target.value);
  };

  const handleConfirmReturn = () => {
    console.log("[handleConfirmReturn] Started. Equipment:", equipmentToReturn);
    console.log("[handleConfirmReturn] Date from drawer:", returnDateInDrawer);

    if (!equipmentToReturn || !equipmentToReturn.id) return;

    // 1. Validação: Data preenchida (Única validação restante)
    if (!returnDateInDrawer) {
      console.log("[handleConfirmReturn] Validation Fail: Date empty");
      setReturnError('Por favor, informe a data de devolução.');
      return;
    }

    // 2. Validação removida (Data de devolução vs entrega)
    /*
    if (equipmentToReturn.delivery_date) {
      const deliveryDateStr = equipmentToReturn.delivery_date; // Assume YYYY-MM-DD
      const returnDateStr = returnDateInDrawer;             // Assume YYYY-MM-DD

      console.log(`[handleConfirmReturn] Comparing Strings: Return='${returnDateStr}', Delivery='${deliveryDateStr}'`);

      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(returnDateStr) || !dateRegex.test(deliveryDateStr)) {
          console.error("[handleConfirmReturn] Invalid date string format. Expected YYYY-MM-DD.");
          setReturnError('Erro no formato das datas.');
          return;
      }

      if (returnDateStr < deliveryDateStr) {
        console.log("[handleConfirmReturn] Validation Fail: Return date string < Delivery date string");
        setReturnError('A data de devolução não pode ser anterior à data de entrega do equipamento.');
        return; // Impede a continuação
      }
    } else {
      console.warn("[handleConfirmReturn] Cannot validate return date because delivery date is unknown.");
    }
    */

    // Se chegou até aqui, a validação de data preenchida passou.
    console.log("[handleConfirmReturn] Validation Passed (only checked if date exists). Updating state...");
    setReturnError(null); // Limpa qualquer erro anterior

    // Atualiza o estado local do contrato
    setContract(prev => ({
      ...prev,
      contract_equipments: (prev.contract_equipments || []).map(eq =>
        eq.id === equipmentToReturn.id
          ? { ...eq, return_date: returnDateInDrawer } // Atualiza a data
          : eq
      )
    }));

    handleCloseReturnDrawer(); // Fecha o drawer
  };
  // --- FIM dos Handlers Movidos ---

  // Handler para formatar valor para 2 casas decimais ao perder o foco
  const handleValorBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name } = event.target; 

    const isAditivoField = name === 'aditivoValor';
    const displayValue = isAditivoField ? aditivoValorDisplay : valorDisplay;
    // Ajustar o stateSetter para lidar com Partial<AditivoContratual>
    const stateSetter = isAditivoField ? 
      (fn: (prevState: Partial<AditivoContratual>) => Partial<AditivoContratual>) => setCurrentAditivo(fn) :
      (fn: (prevState: ContractFormData) => ContractFormData) => setContract(fn);
      
    const fieldName = 'value'; 

    const numericValue = parseCurrencyValue(displayValue);

    stateSetter((prev: any) => ({ ...prev, [fieldName]: numericValue }));

    const finalFormatted = formatCurrency(numericValue);
    if (isAditivoField) {
        setAditivoValorDisplay(finalFormatted);
    } else {
        setValorDisplay(finalFormatted);
    }
  };

  // Função que REALMENTE salva (chamada após confirmação)
  const handleConfirmSave = async () => {
    setIsConfirmDialogOpen(false); // Fecha o diálogo
    if (isViewMode) return; // Segurança extra
    
    // --- Validação de Campos Obrigatórios (Movida para cá) --- 
    const requiredFields: (keyof ContractFormData)[] = [
      'company_id', 
      'person_id', 
      'contract_payment_type_id',
      'value', 
      'contract_start_date'
    ];
    const missingFields = requiredFields.filter(field => 
      contract[field] === undefined || contract[field] === null || contract[field] === ''
    );

    if (missingFields.length > 0) {
      const fieldNamesMap: Record<string, string> = {
          company_id: 'Empresa',
          person_id: 'Pessoa (Prestador)',
          contract_payment_type_id: 'Tipo de Pagamento',
          value: 'Valor (R$)',
          contract_start_date: 'Data Início Contrato'
      };
      const missingFieldNames = missingFields.map(f => fieldNamesMap[f] || f).join(', ');
      setError(`Por favor, preencha os campos obrigatórios: ${missingFieldNames}.`);
      return; 
    }
    // --- Fim da Validação ---

    setError(null); 
    setSaving(true);

    try {
      // ** Preparar dados para envio **
      type MappedSuspension = {
        id?: number;
        date: string | null;
        days: number | undefined;
        contract_operation_suspended_id: number | undefined;
        observation: string | undefined;
      };
      const dataToSend: Partial<ContractFormData> & { aditivos?: any[], suspensao?: any[] } = {
        company_id: contract.company_id,
        person_id: contract.person_id,
        contract_start_date: contract.contract_start_date,
        contract_payment_type_id: contract.contract_payment_type_id,
        value: parseCurrencyValue(valorDisplay) ?? contract.value,
        observation_start: contract.observation_start,
        active: contract.active,
        contract_reason_termination_id: contract.contract_reason_termination_id,
        termination_date: contract.termination_date,
        termination_observations: contract.termination_observations,
        contract_equipments: (contract.contract_equipments ?? []).map(eq => ({ 
          id: eq.id, 
          equipment_id: eq.equipment_id,
          delivery_date: eq.delivery_date,
          return_date: eq.return_date,
          return_motive: eq.return_motive,
        })),
      };

      if (isEditMode) {
        dataToSend.aditivos = (contract.contractAdditives ?? []).map(aditivo => {
          const motiveIds = (aditivo.motives || []).map(motive => motive.id);
          const baseAditivoData: any = {
              additive_date: aditivo.additive_date,
              contract_payment_type_id: aditivo.contract_payment_type_id,
              value: aditivo.value,
              contract_additive_motives: motiveIds,
              observations: aditivo.observations,
            };
            return typeof aditivo.id === 'number' 
              ? { ...baseAditivoData, id: aditivo.id } 
              : baseAditivoData;
        });

        dataToSend.suspensao = (contract.suspensao ?? []).map((susp) => ({ 
            id: typeof susp.id === 'number' ? susp.id : undefined,
          date: susp.data, 
          days: susp.qtdDiasUteis, 
            contract_operation_suspended_id: susp.contract_operation_suspended_id,
          observation: susp.observacoes
        })) as any[]; 
      }

      if (!isEditMode) {
        delete dataToSend.contract_reason_termination_id;
        delete dataToSend.termination_date;
        delete dataToSend.termination_observations;
        delete dataToSend.termination_user_id;
        delete dataToSend.termination_datetime;
      }

      console.log("Dados a serem enviados (handleConfirmSave):", dataToSend);

      let successMessage = ''; // Variável para a mensagem de sucesso
      let savedContractId: number;

      if (isEditMode && id) { 
        console.log(`Atualizando contrato ${id}...`);
        await contractService.update(parseInt(id), dataToSend);
        successMessage = "Contrato atualizado com sucesso.";
        savedContractId = parseInt(id);
      } else { 
        console.log("Criando novo contrato...");
        const response = await contractService.create(dataToSend);
        successMessage = "Contrato criado com sucesso.";
        savedContractId = response.id;
      }

      // Mostrar Snackbar
      setSnackbarMessage(successMessage);
      setSnackbarOpen(true);

      // Recarregar os dados do contrato
      if (savedContractId) {
        const updatedContractData = await contractService.getById(savedContractId);
        
        // Atualizar o estado com os novos dados
        const mappedData: ContractFormData = {
          ...updatedContractData,
          company_id: updatedContractData.company_id ?? undefined,
          person_id: updatedContractData.person_id ?? undefined,
          contract_payment_type_id: updatedContractData.contract_payment_type_id ?? undefined,
          contract_start_date: updatedContractData.contract_start_date ? new Date(updatedContractData.contract_start_date).toISOString().split('T')[0] : '',
          value: typeof updatedContractData.value === 'string' ? parseFloat(updatedContractData.value) : updatedContractData.value,
          observation_start: updatedContractData.observation_start || '',
          active: updatedContractData.active ?? true,
          contractAdditives: updatedContractData.contractAdditives || [],
          contract_equipments: updatedContractData.contract_equipments || [],
          suspensao: updatedContractData.suspensao || [],
          contract_reason_termination_id: updatedContractData.contract_reason_termination_id ?? undefined,
          termination_date: updatedContractData.contract_termination_date ? new Date(updatedContractData.contract_termination_date).toISOString().split('T')[0] : '',
          termination_observations: updatedContractData.observation_termination || '',
        };

        setContract(mappedData);
        
        // Se for um novo contrato, atualizar a URL para o modo de edição
        if (!isEditMode) {
          navigate(`/contracts/edit/${savedContractId}`, { replace: true });
        }
      }

    } catch (err: any) {
      console.error("Erro ao salvar contrato:", err);
      setError(err.response?.data?.message || err.message || 'Falha ao salvar contrato.');
    } finally {
      setSaving(false);
    }
  };

  // Função chamada pelo botão SALVAR original (agora só abre o diálogo)
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isViewMode) return;
    // Apenas abre o diálogo de confirmação
    setIsConfirmDialogOpen(true);
  };

  // Função para fechar o diálogo sem salvar
  const handleCancelSave = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    navigate('/contracts');
  };

  // --- Cálculos para Paginação e Seleção (MOVER PARA ANTES DO LOADING CHECK) ---
  const aditivosToShow = useMemo(() => {
    console.log("useMemo (aditivosToShow) - contract.contractAdditives:", contract.contractAdditives);
    const result = (contract.contractAdditives || []).slice(aditivosPage * aditivosRowsPerPage, aditivosPage * aditivosRowsPerPage + aditivosRowsPerPage);
    console.log("useMemo (aditivosToShow) - result:", result);
    return result;
  } , [contract.contractAdditives, aditivosPage, aditivosRowsPerPage]);
  
  const equipmentsToShow = useMemo(() => {
    // Adicionar log dentro do useMemo
    console.log("useMemo (equipmentsToShow) - contract.contract_equipments:", contract?.contract_equipments);
    const result = (contract.contract_equipments || []).slice(equipmentsPage * equipmentsRowsPerPage, equipmentsPage * equipmentsRowsPerPage + equipmentsRowsPerPage);
    console.log("useMemo (equipmentsToShow) - result:", result);
    return result;
  } , [contract.contract_equipments, equipmentsPage, equipmentsRowsPerPage]); // Manter como estava

  const suspensionsToShow = useMemo(() => 
    (contract.suspensao || []).slice(suspensionsPage * suspensionsRowsPerPage, suspensionsPage * suspensionsRowsPerPage + suspensionsRowsPerPage)
  , [contract.suspensao, suspensionsPage, suspensionsRowsPerPage]);

  // Calcular equipamentos disponíveis para seleção no drawer (ANTES do loading check)
  const equipmentsForSelect = useMemo(() => {
    const alocadosIds = new Set((contract.contract_equipments || []).map((aloc: EquipamentoAlocado) => aloc.equipment_id)); // Correção: usar contract_equipments
    return availableEquipments.filter(eq => !alocadosIds.has(eq.id));
  }, [availableEquipments, contract.contract_equipments]); // Correção: usar contract_equipments

  // Função auxiliar para buscar nome do tipo de pagamento pelo ID
  const getPaymentTypeName = (id: number | undefined): string => {
    if (id === undefined) return '-';
    return paymentTypes.find(pt => pt.id === id)?.name || 'Desconhecido';
  };

  // --- Renderização --- 
  // Verificar loading DEPOIS de todos os hooks
  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}><CircularProgress /></Box>;
  }

  // --- Funções Helper (Podem ficar aqui) --- 
  const formatDateTime = (isoString: string | undefined | Date): { date: string; time: string } => {
    if (!isoString) return { date: '-', time: '-' };
    try {
        const dateObj = typeof isoString === 'string' ? new Date(isoString) : isoString;
        if (isNaN(dateObj.getTime())) return { date: '-', time: '-' }; // Invalid date
        const date = dateObj.toLocaleDateString('pt-BR');
        const time = dateObj.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
        return { date, time };
    } catch (e) {
        console.error("Error formatting date-time:", e);
        return { date: '-', time: '-' };
    }
  };
  const disableFields = saving || loading || isViewMode;
  const disableEmpresaPessoa = saving || loading || !!id;
  const getPageTitle = () => {
      if (isViewMode) return 'Visualizar Contrato';
      if (isEditMode) return 'Editar Contrato';
      return 'Novo Contrato';
  }

  // --- Handler para Remover Aditivo (Apenas localmente) ---
  const handleRemoveAditivo = (aditivoIdToRemove: number | string) => {
    // Atualiza apenas o estado local removendo o aditivo
    setContract(prev => ({
      ...prev,
      contractAdditives: prev.contractAdditives?.filter(aditivo => aditivo.id !== aditivoIdToRemove)
    }));
  };

  // Função para fechar o Snackbar
  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return; // Não fechar se clicar fora da área
    }
    setSnackbarOpen(false);
  };

  return (
    <Box>
      <Typography variant="h5" component="h1" sx={{ mb: 2 }}>
        {getPageTitle()}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2, py: 0.5, fontSize: '0.875rem' }}>
          {error}
        </Alert>
      )}

      <Card elevation={2}>
        <Tabs 
          value={currentTab} 
          onChange={handleTabChange} 
          aria-label="abas do contrato"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              fontSize: '0.85rem',
              py: 1,
              minHeight: 40
            }
          }}
        >
          <Tab label="Dados" icon={<FileText size={16} />} iconPosition="start" {...a11yProps(0)} />
          <Tab label="Equipamentos" icon={<HardDrive size={16} />} iconPosition="start" {...a11yProps(1)} />
          <Tab 
            label="Aditivos" 
            icon={<FilePlus size={16} />} 
            iconPosition="start" 
            disabled={!isEditMode && !isViewMode}
            {...a11yProps(2)} 
          />
          <Tab 
            label="Suspensão" 
            icon={<PauseCircle size={16} />} 
            iconPosition="start" 
            disabled={!isEditMode && !isViewMode}
            {...a11yProps(3)} 
          />
          <Tab 
            label="Encerramento" 
            icon={<FileX size={16} />} 
            iconPosition="start" 
            disabled={!isEditMode && !isViewMode}
            {...a11yProps(4)} 
          />
        </Tabs>

        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TabPanel value={currentTab} index={0}>
              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth required error={!contract.company_id && !!error} margin="dense" size="small">
                    <InputLabel id="empresa-label" sx={{ fontSize: '0.85rem' }}>Empresa</InputLabel>
                    <Select
                      labelId="empresa-label"
                      name="company_id"
                      value={contract.company_id ?? ''}
                      label="Empresa"
                      onChange={handleSelectChange}
                      disabled={disableEmpresaPessoa}
                      sx={{ 
                          fontSize: '0.85rem',
                          height: 40
                      }}
                    >
                      <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}><em>Selecione...</em></MenuItem>
                      {companies.map((company) => (
                        <MenuItem key={company.id} value={company.id} sx={{ fontSize: '0.85rem' }}>
                          {company.name} {company.fantasy_name ? `(${company.fantasy_name})` : ''}
                        </MenuItem>
                      ))}
                    </Select>
                    {!contract.company_id && !!error && <FormHelperText error sx={{ fontSize: '0.75rem' }}>Campo obrigatório</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth required error={!contract.person_id && !!error} margin="dense" size="small">
                    <InputLabel id="pessoa-label" sx={{ fontSize: '0.85rem' }}>Pessoa (Prestador)</InputLabel>
                    <Select
                      labelId="pessoa-label"
                      name="person_id"
                      value={contract.person_id ?? ''}
                      label="Pessoa (Prestador)"
                      onChange={handleSelectChange}
                      disabled={disableEmpresaPessoa}
                      sx={{ 
                          fontSize: '0.85rem',
                          height: 40
                      }}
                    >
                      <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}><em>Selecione...</em></MenuItem>
                      {persons.map((person) => (
                        <MenuItem key={person.id} value={person.id} sx={{ fontSize: '0.85rem' }}>
                          {person.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {!contract.person_id && !!error && <FormHelperText error sx={{ fontSize: '0.75rem' }}>Campo obrigatório</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControl fullWidth required error={!contract.contract_payment_type_id && !!error} margin="dense" size="small">
                    <InputLabel id="tipo-pagamento-label" sx={{ fontSize: '0.85rem' }}>Tipo de Pagamento</InputLabel>
                    <Select
                      labelId="tipo-pagamento-label"
                      name="contract_payment_type_id"
                      value={contract.contract_payment_type_id ?? ''}
                      label="Tipo de Pagamento"
                      onChange={handleSelectChange}
                      disabled={disableFields || isEditMode}
                      sx={{ fontSize: '0.85rem', height: 40 }}
                    >
                      <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}>
                        <em>Selecione...</em>
                      </MenuItem>
                      {paymentTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id} sx={{ fontSize: '0.85rem' }}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {!contract.contract_payment_type_id && !!error && <FormHelperText error sx={{ fontSize: '0.75rem' }}>Campo obrigatório</FormHelperText>}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name="value"
                    label="Valor (R$)"
                    type="text"
                    value={valorDisplay}
                    onChange={handleInputChange}
                    onBlur={handleValorBlur}
                    fullWidth
                    required
                    error={contract.value === undefined && !!error}
                    helperText={contract.value === undefined && !!error ? 'Campo obrigatório' : 'Ex: 1.234,56'}
                    disabled={disableFields || (!isEditMode && !contract.active)} // <<< Modificar esta linha
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }}
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      inputProps: { 
                        inputMode: "numeric"
                      },
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                    FormHelperTextProps={{
                      style: { fontSize: '0.75rem', marginTop: '2px' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    name="contract_start_date"
                    label="Data Início Contrato"
                    type="date"
                    value={contract.contract_start_date || ''}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    error={!contract.contract_start_date && !!error}
                    helperText={!contract.contract_start_date && !!error ? 'Campo obrigatório' : ''}
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }}
                    disabled={disableFields || !contract.active} // Adicionado !contract.active
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                    FormHelperTextProps={{
                      style: { fontSize: '0.75rem', marginTop: '2px' }
                    }}
                  />
                </Grid>
                {(isEditMode || isViewMode) && (
                  <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center', height: '56px', mt: '8px' }}>
                    {/* <<< APLICAR NOVO ESTILO AO CHIP DE STATUS >>> */}
                    <Chip 
                      label={contract.active ? "Ativo" : "Encerrado"}
                      color={contract.active ? "success" : "error"} // <<< Usar 'error' para Encerrado
                      size="small"
                      sx={{
                        fontWeight: 'bold',
                        color: 'white', // <<< Texto branco
                        // Opcional: Ajustar padding ou altura se necessário
                        height: '24px', 
                        '& .MuiChip-label': {
                          padding: '0px 8px' // Ajustar padding horizontal
                        }
                      }}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Observações Gerais"
                    name="observation_start"
                    value={contract.observation_start || ''}
                    onChange={handleInputChange}
                    multiline
                    rows={4}
                    margin="dense"
                    disabled={disableFields || !contract.active} // Adicionado !contract.active
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' }
                    }}
                    InputLabelProps={{ 
                      style: { fontSize: '0.85rem' } 
                    }}
                    FormHelperTextProps={{
                      style: { fontSize: '0.75rem', marginTop: '2px' }
                    }}
                  />
                </Grid>
              </Grid>

              {/* --- Seção de Auditoria Unificada --- */}
              {(isEditMode || isViewMode) && contract && (
                  <Paper sx={{ p: 2, bgcolor: 'background.default', mt: 3, border: `1px solid ${theme.palette.divider}` }}>
                      <Typography variant="subtitle2" sx={{ mb: 1.5, fontSize: '0.9rem', fontWeight: 'bold' }}>
                          Auditoria
                      </Typography>
                      <Grid container spacing={1.5}> {/* Aumentar espaçamento se necessário */}
                          {/* Criação */}
                          <Grid item xs={12} sm={6} md={3}> 
                              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                  {/* Aplicar cor de desabilitado ao label */}
                                  <strong style={{ color: theme.palette.text.disabled }}>Criado por:</strong><br />
                                  {(contract as any).CreatedBy?.name || '-'}
                              </Typography>
                </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                              <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                  {/* Aplicar cor de desabilitado ao label */}
                                  <strong style={{ color: theme.palette.text.disabled }}>Criado em:</strong><br />
                                  {(contract as any).createdAt
                                      ? `${formatDateTime((contract as any).createdAt).date} ${formatDateTime((contract as any).createdAt).time}`
                                      : '-'}
                              </Typography>
                </Grid>

                          {/* Última Alteração (Condicional) */}
                          {(contract as any).updatedAt && (
                            <>
                              <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                    {/* Aplicar cor de desabilitado ao label */}
                                    <strong style={{ color: theme.palette.text.disabled }}>Alterado por:</strong><br />
                                    {(contract as any).UpdatedBy?.name || '-'}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                                    {/* Aplicar cor de desabilitado ao label */}
                                    <strong style={{ color: theme.palette.text.disabled }}>Alterado em:</strong><br />
                                    {`${formatDateTime((contract as any).updatedAt).date} ${formatDateTime((contract as any).updatedAt).time}`}
                                </Typography>
                              </Grid>
                            </>
                          )}
                </Grid>
                  </Paper>
              )}

            </TabPanel>

            <TabPanel value={currentTab} index={1}>
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontSize: '1rem' }}>Equipamentos Alocados</Typography>
                  <Button
                    startIcon={<PlusCircle size={16} />}
                    onClick={handleOpenAssociateDrawer}
                    disabled={isViewMode || !contract.active} // Adicionado !contract.active
                    variant="outlined"
                    size="small"
                    sx={{ fontSize: '0.75rem' }}
                  >
                    Associar Equipamento
                  </Button>
                </Box>
                
                <TableContainer component={Paper} elevation={1}>
                  <Table sx={{ minWidth: 650 }} size="small">
                    <TableHead>
                      <TableRow>
                        {/* Mover Data Entrega para ser a primeira */} 
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Data Entrega</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Equipamento</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Data Devolução</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Lançado por</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {equipmentsToShow.length > 0 ? (
                        equipmentsToShow.map((alocacao: EquipamentoAlocado) => { 
                          const isReturned = !!alocacao.return_date;
                          const formattedDateTime = formatDateTime(alocacao.createdAt);
                          return (
                            <TableRow key={alocacao.id ?? alocacao.equipment_id}> 
                              {/* Mover Data Entrega para ser a primeira */} 
                              <TableCell sx={{ fontSize: '0.85rem' }}>{alocacao.delivery_date ? new Date(alocacao.delivery_date).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '-'}</TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>
                                {/* Buscar detalhes completos do equipamento */} 
                                {(() => {
                                  const equipmentDetails = availableEquipments.find(eq => eq.id === alocacao.equipment_id);
                                  const typeName = equipmentDetails?.EquipmentType?.name || 'Tipo?';
                                  const brandName = equipmentDetails?.EquipmentBrand?.name || 'Marca?';
                                  const modelName = equipmentDetails?.model || alocacao.equipment_model || 'S/Modelo'; // Fallback para o dado da alocação
                                  const serialNumber = equipmentDetails?.serial_number || alocacao.equipment_serial || 'S/N'; // Fallback para o dado da alocação

                                  return (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <Typography component="span" sx={{ fontSize: '0.85rem', lineHeight: 1.3 }}>
                                        {`${typeName} - ${brandName} - ${modelName}`}
                                      </Typography>
                                      <Typography component="span" sx={{ fontSize: '0.70rem', color: 'text.secondary', lineHeight: 1.2 }}>
                                        Serial: {serialNumber}
                                      </Typography>
                                    </Box>
                                  );
                                })()}
                              </TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>{alocacao.return_date ? new Date(alocacao.return_date).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '-'}</TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  <Typography component="span" sx={{ fontSize: '0.85rem', lineHeight: 1.3 }}>
                                    {alocacao.CreatedBy?.name || '-'}
                                  </Typography>
                                  <Typography component="span" sx={{ fontSize: '0.70rem', color: 'text.secondary', lineHeight: 1.2 }}>
                                    {formattedDateTime.date !== '-' ? `${formattedDateTime.date} ${formattedDateTime.time}` : '-'}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell>
                                {/* Botão REMOVER - Sempre visível, desabilitado se viewMode ou item já salvo */} 
                                <Tooltip title="Remover Associação">
                                  <span> {/* Span necessário para Tooltip em botão desabilitado */} 
                                    <IconButton 
                                      size="small" 
                                      color="error" 
                                      onClick={() => handleRemoveEquipment(alocacao.equipment_id)}
                                      disabled={isViewMode || !!alocacao.id} // Condição de desabilitar
                                    >
                                      <Trash2 size={16} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                
                                {/* Botão DEVOLVER - Sempre visível, desabilitado se viewMode, item não salvo ou já devolvido */} 
                                <Tooltip title="Registrar Devolução">
                                  <span> {/* Span necessário para Tooltip em botão desabilitado */} 
                                    <IconButton 
                                      size="small" 
                                      color="primary" 
                                      onClick={() => handleOpenReturnDrawer(alocacao)}
                                      disabled={isViewMode || !alocacao.id || isReturned} // Condição de desabilitar
                                    >
                                      <Undo2 size={16} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          {/* Ajustar colSpan para 5 (4 colunas + Ações) */} 
                          <TableCell colSpan={5} align="center" sx={{ fontSize: '0.85rem' }}>
                            Nenhum equipamento alocado.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {equipmentsToShow.length > 0 && (
                  <TablePagination
                    component="div"
                    count={(contract.contract_equipments || []).length} // Correção: usar contract_equipments
                    page={equipmentsPage}
                    onPageChange={handleChangeEquipmentsPage}
                    rowsPerPage={equipmentsRowsPerPage}
                    onRowsPerPageChange={handleChangeEquipmentsRowsPerPage}
                    labelRowsPerPage="Linhas por página:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    rowsPerPageOptions={[5, 10, 25]}
                    sx={{ 
                      '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows, .MuiTablePagination-select, .MuiTablePagination-selectIcon': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                )}
              </Box>
            </TabPanel>
            
            <TabPanel value={currentTab} index={2}>
              <Box>
                {/* {console.log("Render TabPanel 2 - aditivosToShow:", aditivosToShow)} <- Log removido */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontSize: '1rem' }}>Aditivos Contratuais</Typography>
                  <Button
                    startIcon={<PlusCircle size={16} />}
                    onClick={handleOpenAditivoDrawer}
                    disabled={isViewMode || !contract.active} // Adicionado !contract.active
                    variant="outlined"
                    size="small"
                    sx={{ fontSize: '0.75rem' }}
                  >
                    Novo Aditivo
                  </Button>
                </Box>
                
                <TableContainer component={Paper} elevation={1}>
                  <Table sx={{ minWidth: 650 }} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Data</TableCell>
                        {/* Remover colunas antigas e adicionar nova */}
                        {/* 
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Tipo</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Valor (R$)</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Motivos</TableCell> 
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Justificativa</TableCell>
                        */}
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Aditivo</TableCell> {/* Nova Coluna */} 
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Lançado por</TableCell> 
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {aditivosToShow.length > 0 ? (
                        aditivosToShow.map((aditivo: AditivoContratual) => { 
                          // Remover cálculo de motivoNome obsoleto
                          // const motivoNome = aditivo.motive?.name || '-'; // REMOVER
                          
                          const formattedDateTime = formatDateTime(aditivo.created_at);
                          const tipoPagamentoNome = aditivo.paymentType?.name || '-'; 
                          const valorFormatado = aditivo.value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || '-';
                          const motivosNomes = aditivo.motives && aditivo.motives.length > 0 
                                             ? aditivo.motives.map(m => m.name).join(', ') 
                                             : '-';
                          const justificativa = aditivo.observations || '-';

                          return (
                            <TableRow key={aditivo.id}> 
                              <TableCell sx={{ fontSize: '0.85rem' }}>{aditivo.additive_date ? formatDateToBR(aditivo.additive_date) : '-'}</TableCell>
                              
                              {/* Remover células antigas */}
                              {/* 
                              <TableCell sx={{ fontSize: '0.85rem' }}>{tipoPagamentoNome}</TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>{valorFormatado}</TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>{motivosNomes}</TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>{justificativa}</TableCell>
                              */}

                              {/* Nova célula Aditivo */}
                              <TableCell sx={{ fontSize: '0.85rem' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  {/* Primeira linha: Motivos como Chips */}
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 0.2 }}>
                                    {aditivo.motives && aditivo.motives.length > 0 ? (
                                      aditivo.motives.map((motive) => (
                                        <Chip 
                                          key={motive.id} 
                                          label={motive.name} 
                                          size="small" 
                                          sx={{ 
                                            fontSize: '0.70rem', // Fonte ainda menor para chips pequenos
                                            height: '20px', // Altura ligeiramente menor
                                            backgroundColor: theme.palette.grey[300] // Alterado para 300
                                          }} 
                                        />
                                      ))
                                    ) : (
                                      <Typography component="span" sx={{ fontSize: '0.85rem', fontWeight: 500, lineHeight: 1.3 }}>
                                        -
                                      </Typography>
                                    )}
                                  </Box>
                                  {/* Segunda linha: Valor (Tipo) */}
                                  <Typography component="span" sx={{ fontSize: '0.80rem', lineHeight: 1.2, my: 0.2 /* Usar my para espaço */ }}>
                                    {valorFormatado} ({tipoPagamentoNome})
                                  </Typography>
                                  {/* Terceira linha: Justificativa */}
                                  <Typography component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary', lineHeight: 1.2, mt: 0.2 /* Pequeno espaço */ }}>
                                    {justificativa}
                                  </Typography>
                                </Box>
                              </TableCell>

                              {/* Célula "Lançado por" */}
                              <TableCell sx={{ fontSize: '0.85rem' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  <Typography component="span" sx={{ fontSize: '0.85rem', lineHeight: 1.3 }}>
                                    {aditivo.CreatedBy?.name || '-'}
                                  </Typography>
                                  <Typography component="span" sx={{ fontSize: '0.70rem', color: 'text.secondary', lineHeight: 1.2 }}>
                                    {formattedDateTime.date !== '-' ? `${formattedDateTime.date} ${formattedDateTime.time}` : '-'}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell>
                                {/* Botão REMOVER - Agora habilitado mesmo após salvo */}
                                <Tooltip title="Remover Aditivo">
                                  <span> {/* Necessário para Tooltip em botão desabilitado */} 
                                    <IconButton 
                                      size="small" 
                                      color="error" 
                                      onClick={() => handleRemoveAditivo(aditivo.id!)}
                                      disabled={isViewMode || !contract.active} // Apenas desabilitar em modo visualização ou contrato inativo
                                    >
                                      <Trash2 size={16} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          {/* Ajustar colSpan para 4 (Data, Aditivo, Lançado por, Ações) */} 
                          <TableCell colSpan={4} align="center" sx={{ fontSize: '0.85rem' }}>
                            Nenhum aditivo cadastrado.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {aditivosToShow.length > 0 && (
                  <TablePagination
                    component="div"
                    count={(contract.contractAdditives || []).length} // Usar propriedade correta
                    page={aditivosPage}
                    onPageChange={handleChangeAditivosPage}
                    rowsPerPage={aditivosRowsPerPage}
                    onRowsPerPageChange={handleChangeAditivosRowsPerPage}
                    labelRowsPerPage="Linhas por página:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    rowsPerPageOptions={[5, 10, 25]}
                    sx={{ 
                      '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows, .MuiTablePagination-select, .MuiTablePagination-selectIcon': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                )}
              </Box>
            </TabPanel>

            <TabPanel value={currentTab} index={3}>
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontSize: '1rem' }}>Suspensão do Contrato</Typography>
                  <Button
                    startIcon={<PlusCircle size={16} />}
                    onClick={handleOpenSuspensionDrawer}
                    disabled={isViewMode || !contract.active} // Adicionado !contract.active
                    variant="outlined"
                    size="small"
                    sx={{ fontSize: '0.75rem' }}
                  >
                    Nova Suspensão
                  </Button>
                </Box>
                
                <TableContainer component={Paper} elevation={1}>
                  <Table sx={{ minWidth: 650 }} size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Data</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Qtd Dias Úteis</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Operação</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Observações</TableCell>
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Lançado por</TableCell> {/* Nova Coluna */}
                        <TableCell sx={{ fontSize: '0.85rem', fontWeight: 'bold' }}>Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {suspensionsToShow.length > 0 ? (
                        suspensionsToShow.map((suspensao) => {
                          // Formatar data e hora de criação
                          const formattedDateTime = formatDateTime((suspensao as any).createdAt); // Usar 'any' temporariamente para acessar createdAt
                          // Formatar data da suspensão (sem hora)
                          const formattedSuspensionDate = suspensao.data ? new Date(suspensao.data).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '-';

                          return (
                            <TableRow key={suspensao.id}>
                              <TableCell sx={{ fontSize: '0.85rem' }}>{formattedSuspensionDate}</TableCell> {/* Data formatada */}
                              <TableCell sx={{ fontSize: '0.85rem' }}>{suspensao.qtdDiasUteis}</TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>
                                {operationSuspendedOptions.find(op => op.id === suspensao.contract_operation_suspended_id)?.name || '-'}
                              </TableCell>
                              <TableCell sx={{ fontSize: '0.85rem' }}>{suspensao.observacoes || '-'}</TableCell>
                              {/* Nova Célula "Lançado por" */}
                              <TableCell sx={{ fontSize: '0.85rem' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                  <Typography component="span" sx={{ fontSize: '0.85rem', lineHeight: 1.3 }}>
                                    {/* Exibe o nome do criador se existir (normalmente só após salvar) */}
                                    {(suspensao as any).CreatedBy?.name || '-'} 
                                  </Typography>
                                  <Typography component="span" sx={{ fontSize: '0.70rem', color: 'text.secondary', lineHeight: 1.2 }}>
                                    {/* Exibe data/hora SOMENTE se o ID for numérico (registro salvo) */}
                                    {typeof suspensao.id === 'number' && formattedDateTime.date !== '-' 
                                      ? `${formattedDateTime.date} ${formattedDateTime.time}` 
                                      : '-'}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell>
                                {/* Botão REMOVER - Agora habilitado mesmo após salvo */}
                                <Tooltip title="Remover Suspensão">
                                  <span> {/* Span necessário para Tooltip em botão desabilitado */} 
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => handleRemoveSuspension(suspensao.id!)}
                                      disabled={isViewMode || !contract.active} // Apenas desabilitar em modo visualização ou contrato inativo
                                    >
                                      <Trash2 size={16} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          {/* Ajustar colSpan para 6 (5 colunas + Ações) */}
                          <TableCell colSpan={6} align="center" sx={{ fontSize: '0.85rem' }}>
                            Nenhuma suspensão cadastrada.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {suspensionsToShow.length > 0 && (
                  <TablePagination
                    component="div"
                    count={(contract.suspensao || []).length}
                    page={suspensionsPage}
                    onPageChange={handleChangeSuspensionsPage}
                    rowsPerPage={suspensionsRowsPerPage}
                    onRowsPerPageChange={handleChangeSuspensionsRowsPerPage}
                    labelRowsPerPage="Linhas por página:"
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    rowsPerPageOptions={[5, 10, 25]}
                    sx={{ 
                      '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows, .MuiTablePagination-select, .MuiTablePagination-selectIcon': {
                        fontSize: '0.75rem',
                      }
                    }}
                  />
                )}
              </Box>
            </TabPanel>

            <TabPanel value={currentTab} index={4}>
              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth margin="dense" size="small">
                    <InputLabel id="reason-termination-label" sx={{ fontSize: '0.85rem' }}>Motivo do Encerramento</InputLabel>
                    <Select
                      labelId="reason-termination-label"
                      name="contract_reason_termination_id"
                      value={contract.contract_reason_termination_id || ''}
                      onChange={handleSelectChange}
                      label="Motivo do Encerramento"
                      disabled={saving || isViewMode || !contract.active} // Adicionado !contract.active e removido saving (já em disableFields)
                      sx={{ fontSize: '0.85rem', height: 40 }}
                    >
                      <MenuItem value="" sx={{ fontSize: '0.85rem' }}>
                        <em>Nenhum (Contrato Ativo)</em>
                      </MenuItem>
                      {reasonTerminationOptions.map((reason) => (
                        <MenuItem key={reason.id} value={reason.id} sx={{ fontSize: '0.85rem' }}>
                          {reason.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <TextField
                    name="termination_date"
                    label="Data do Encerramento"
                    type="date"
                    value={contract.termination_date || ''}
                    onChange={handleInputChange}
                    fullWidth
                    disabled={saving || isViewMode || !contract.active} // Simplificado para !contract.active
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }}
                    FormHelperTextProps={{
                      style: { fontSize: '0.75rem', marginTop: '2px' }
                    }}
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Observações do Encerramento"
                    name="termination_observations"
                    value={contract.termination_observations || ''}
                    onChange={handleInputChange}
                    multiline
                    rows={4}
                    margin="dense"
                    disabled={saving || isViewMode || !contract.active} // Simplificado para !contract.active
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' }
                    }}
                    InputLabelProps={{ 
                      style: { fontSize: '0.85rem' } 
                    }}
                    FormHelperTextProps={{
                      style: { fontSize: '0.75rem', marginTop: '2px' }
                    }}
                  />
                </Grid>
                
                {(contract.termination_user_id || contract.termination_datetime) && (
                  <Grid item xs={12}>
                    <Paper sx={{ p: 2, bgcolor: 'background.default', mt: 2 }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, fontSize: '0.85rem' }}>
                        Informações do Encerramento
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                            <strong>Usuário:</strong> {contract.termination_user_id || '-'}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                            <strong>Data/Hora:</strong> {contract.termination_datetime ? 
                              formatDateTime(contract.termination_datetime).date + ' ' + 
                              formatDateTime(contract.termination_datetime).time : '-'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </TabPanel>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
              {/* Botão Voltar Lista à esquerda */}
              <Button
                variant="outlined"
                startIcon={<ArrowLeft size={16} />}
                onClick={() => navigate('/contracts')}
                size="small"
                sx={{ 
                  px: 2, 
                  py: 0.5,
                  height: 36,
                  fontWeight: 'bold',
                  fontSize: '0.75rem',
                  borderRadius: 1
                }}
              >
                VOLTAR LISTA
              </Button>

              {/* Stack com botões Cancelar e Salvar à direita */}
              <Stack direction="row" spacing={1.5}>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  disabled={saving}
                  size="small"
                  sx={{ 
                    px: 2, 
                    py: 0.5,
                    height: 36,
                    fontWeight: 'bold',
                    fontSize: '0.75rem',
                    borderRadius: 1
                  }}
                >
                  CANCELAR
                </Button>
                {/* Só renderiza o botão Salvar se NÃO estiver em modo de visualização */}
                {!isViewMode && (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <Save size={16} />}
                    disabled={saving || (isEditMode && !isAdmin)}
                    size="small"
                    sx={{ 
                      px: 2, 
                      py: 0.5,
                      height: 36,
                      fontWeight: 'bold',
                      fontSize: '0.75rem',
                      borderRadius: 1
                    }}
                  >
                    {saving ? 'SALVANDO...' : 'SALVAR'}
                  </Button>
                )}
              </Stack>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Drawer
          anchor="right"
          open={isAditivoDrawerOpen}
          onClose={handleCloseAditivoDrawer}
      >
          <Box sx={{ width: 450, p: 2 }} role="presentation">
              <Typography variant="h6" gutterBottom sx={{ mb: 2, fontSize: '1.1rem' }}>
                {currentAditivo.id ? 'Editar Aditivo' : 'Novo Aditivo'}
              </Typography>
              {aditivoError && <Alert severity="error" sx={{ mb: 2, py: 0.5, fontSize: '0.875rem' }}>{aditivoError}</Alert>}
              <Stack spacing={1.5}>
                  <TextField 
                    name="additive_date" 
                    label="Data do Aditivo" 
                    type="date" 
                    value={currentAditivo.additive_date || ''} 
                    onChange={handleAditivoInputChange} 
                    fullWidth 
                    required 
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }} 
                    error={!!(aditivoError && !currentAditivo.additive_date)} 
                    margin="dense" 
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                  />
                  <FormControl fullWidth required error={!!(aditivoError && !currentAditivo.contract_payment_type_id)} margin="dense" size="small">
                    <InputLabel id="aditivo-tipo-pagamento-label" sx={{ fontSize: '0.85rem' }}>Tipo Pagamento</InputLabel>
                    <Select 
                      name="contract_payment_type_id" 
                      value={currentAditivo.contract_payment_type_id || ''} 
                      onChange={handleAditivoInputChange} 
                      sx={{ 
                        fontSize: '0.85rem',
                        height: 40
                      }}
                    >
                        <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}><em>Selecione...</em></MenuItem>
                        {paymentTypes.map((tipo) => (<MenuItem key={tipo.id} value={tipo.id} sx={{ fontSize: '0.85rem' }}>{tipo.name}</MenuItem>))} 
                    </Select>
                    {!!(aditivoError && !currentAditivo.contract_payment_type_id) && <FormHelperText error sx={{ fontSize: '0.75rem' }}>Campo obrigatório</FormHelperText>}
                  </FormControl>
                  <TextField 
                    name="aditivoValor" 
                    label="Valor (R$)"
                    value={aditivoValorDisplay} 
                    onChange={handleAditivoInputChange} 
                    onBlur={handleValorBlur} 
                    fullWidth
                    required
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }} 
                    InputProps={{ 
                      inputProps: { 
                        inputMode: "numeric"
                      },
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }} 
                    helperText="Mantenha o valor atual se não houver alteração." 
                    FormHelperTextProps={{
                      style: { fontSize: '0.75rem', marginTop: '2px' }
                    }}
                    error={!!(aditivoError && currentAditivo.value === undefined)} 
                    margin="dense"
                    size="small" 
                  />
                  {/* Autocomplete para Motivos */}
                  <>
                    <Autocomplete
                      multiple
                      id="aditivo-motivo-select"
                      options={additiveMotives}
                      getOptionLabel={(option) => option.name}
                      value={additiveMotives.filter(motive => 
                        currentAditivo.selectedMotivoIds?.includes(motive.id)
                      )}
                      onChange={(event, newValue) => {
                        const selectedIds = newValue.map(motive => motive.id);
                        setCurrentAditivo({ ...currentAditivo, selectedMotivoIds: selectedIds });
                      }}
                      // Adicionar sx para estilizar o Chip interno
                      sx={{ 
                        '& .MuiChip-root': { // Target the Chip component
                          height: '24px', // Opcional: ajustar altura do chip se necessário
                        },
                        '& .MuiChip-label': { // Target the label inside the Chip
                          fontSize: '0.75rem', // Definir tamanho da fonte menor
                          padding: '0 6px', // Ajustar padding se necessário
                        }
                      }}
                      // Adicionar slotProps para estilizar a lista suspensa
                      slotProps={{
                        paper: { // Target the Paper component of the dropdown
                          sx: {
                            '& .MuiAutocomplete-option': { // Target each option/item
                              fontSize: '0.85rem', // Definir tamanho da fonte menor para as opções
                              minHeight: 'auto', // Ajustar altura mínima se necessário
                              padding: '4px 12px' // Ajustar padding se necessário
                            }
                          }
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Motivos"
                          placeholder="Selecione motivos"
                          // Remover o sx de marginBottom daqui, já que o Autocomplete controla o espaço
                          // sx={{ marginBottom: 2 }} 
                          // Adicionar size="small" e ajustar InputProps/InputLabelProps
                          size="small" 
                          InputLabelProps={{ 
                            style: { fontSize: '0.85rem' } 
                          }}
                          InputProps={{
                            ...params.InputProps, // Manter props originais do Autocomplete
                            style: { fontSize: '0.85rem' },
                            // Remover a altura fixa para permitir ajuste dinâmico
                            // sx: { height: 40 } 
                          }}
                          error={!!(aditivoError && (!currentAditivo.selectedMotivoIds || currentAditivo.selectedMotivoIds.length === 0))} // Adicionar validação de erro
                          helperText={!!(aditivoError && (!currentAditivo.selectedMotivoIds || currentAditivo.selectedMotivoIds.length === 0)) ? 'Campo obrigatório' : ''} // Mensagem de erro
                          FormHelperTextProps={{
                            style: { fontSize: '0.75rem', marginTop: '2px' }
                          }}
                        />
                      )}
                    />
                  </>
                  <TextField 
                    name="observations" 
                    label="Observações (Opcional)" 
                    value={currentAditivo.observations || ''} 
                    onChange={handleAditivoInputChange} 
                    fullWidth 
                    multiline 
                    rows={3} 
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' }
                    }}
                    InputLabelProps={{ 
                      style: { fontSize: '0.85rem' } 
                    }}
                  />
                  <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                      <Button onClick={handleCloseAditivoDrawer} size="small" sx={{ fontSize: '0.75rem' }}>Cancelar</Button>
                      <Button variant="contained" onClick={handleAddAditivo} size="small" sx={{ fontSize: '0.75rem' }}>Adicionar</Button>
                  </Stack>
              </Stack>
          </Box>
      </Drawer>

      <Drawer anchor="right" open={isAssociateDrawerOpen} onClose={handleCloseAssociateDrawer}>
          <Box sx={{ width: 450, p: 2 }} role="presentation">
              <Typography variant="h6" gutterBottom sx={{ mb: 2, fontSize: '1.1rem' }}>Associar Equipamento</Typography>
              {associationError && <Alert severity="error" sx={{ mb: 2, py: 0.5, fontSize: '0.875rem' }}>{associationError}</Alert>}
              <Stack spacing={1.5}>
                  <FormControl fullWidth required error={!!(associationError && !currentAssociation.equipment_id)} margin="dense" size="small">
                      <InputLabel id="equipamento-select-label" sx={{ fontSize: '0.85rem' }}>Equipamento</InputLabel>
                      <Select 
                        labelId="equipamento-select-label" 
                        name="equipment_id" 
                        value={currentAssociation.equipment_id || ''} 
                        label="Equipamento" 
                        onChange={handleAssociationChange}
                        sx={{ 
                          fontSize: '0.85rem',
                          height: 40
                        }} 
                      >
                          <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}><em>Selecione...</em></MenuItem>
                          {equipmentsForSelect.map((eq) => { 
                            // Construir a string da label incluindo tipo, marca, modelo E serial
                            const typeName = eq.EquipmentType?.name || '-';
                            const brandName = eq.EquipmentBrand?.name || '-';
                            const modelName = eq.model || 'S/Modelo'; 
                            const serial = eq.serial_number || 'S/N'; 
                            const label = `${typeName} - ${brandName} - ${modelName} (Serial: ${serial})`; // Serial adicionado aqui
                            return (
                              <MenuItem key={eq.id} value={eq.id} sx={{ fontSize: '0.85rem' }}>
                                {label}
                              </MenuItem>
                            );
                          })} 
                      </Select>
                      {!!(associationError && !currentAssociation.equipment_id) && 
                        <FormHelperText error sx={{ fontSize: '0.75rem' }}>Campo obrigatório</FormHelperText>}
                  </FormControl>
                  <TextField 
                    name="delivery_date" 
                    label="Data de Entrega" 
                    type="date" 
                    value={currentAssociation.delivery_date || ''} 
                    onChange={handleAssociationChange} 
                    fullWidth 
                    required 
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }}
                    error={!!(associationError && !currentAssociation.delivery_date)} 
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                  />
                  <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                      <Button onClick={handleCloseAssociateDrawer} size="small" sx={{ fontSize: '0.75rem' }}>Cancelar</Button>
                      <Button variant="contained" onClick={handleAssociateEquipment} size="small" sx={{ fontSize: '0.75rem' }}>Associar</Button>
                  </Stack>
              </Stack>
          </Box>
      </Drawer>

      <Drawer anchor="right" open={isReturnDrawerOpen} onClose={handleCloseReturnDrawer}>
          <Box sx={{ width: 450, p: 2 }} role="presentation">
              <Typography variant="h6" gutterBottom sx={{ mb: 2, fontSize: '1.1rem' }}>
                Registrar Devolução
              </Typography>
              {equipmentToReturn && ( 
                <Typography variant="body1" sx={{ mb: 2, fontSize: '0.85rem' }}> 
                  Equipamento: <strong>{`${equipmentToReturn.equipment_name || '-'} - ${equipmentToReturn.equipment_model || 'S/Modelo'}`}</strong> 
                </Typography> 
              )}
              {returnError && <Alert severity="error" sx={{ mb: 2, py: 0.5, fontSize: '0.875rem' }}>{returnError}</Alert>}
              <Stack spacing={1.5}>
                  <TextField 
                    name="return_date_drawer" 
                    label="Data de Devolução" 
                    type="date" 
                    value={returnDateInDrawer || ''} 
                    onChange={handleReturnFormChange} 
                    fullWidth 
                    required 
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }}
                    error={!!(returnError && !returnDateInDrawer)} 
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                  />
                  <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                      <Button onClick={handleCloseReturnDrawer} size="small" sx={{ fontSize: '0.75rem' }}>Cancelar</Button>
                      <Button variant="contained" onClick={handleReturnEquipment} size="small" sx={{ fontSize: '0.75rem' }}>Confirmar Devolução</Button>
                  </Stack>
              </Stack>
          </Box>
      </Drawer>

      <Drawer anchor="right" open={isSuspensionDrawerOpen} onClose={handleCloseSuspensionDrawer}>
          <Box sx={{ width: 450, p: 2 }} role="presentation">
              <Typography variant="h6" gutterBottom sx={{ mb: 2, fontSize: '1.1rem' }}>Nova Suspensão</Typography>
              {suspensionError && <Alert severity="error" sx={{ mb: 2, py: 0.5, fontSize: '0.875rem' }}>{suspensionError}</Alert>}
              <Stack spacing={1.5}>
                  <TextField 
                    name="data" 
                    label="Data da Suspensão" 
                    type="date" 
                    value={currentSuspension.data || ''} 
                    onChange={handleSuspensionChange} 
                    fullWidth 
                    required 
                    InputLabelProps={{ 
                      shrink: true,
                      style: { fontSize: '0.85rem' } 
                    }}
                    error={!!(suspensionError && !currentSuspension.data)} 
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                  />
                  <TextField 
                    name="qtdDiasUteis" 
                    label="Qtd Dias Úteis" 
                    type="number" 
                    value={currentSuspension.qtdDiasUteis === undefined ? '' : currentSuspension.qtdDiasUteis} 
                    onChange={handleSuspensionChange} 
                    fullWidth 
                    required 
                    InputProps={{ 
                      inputProps: { min: 1 },
                      style: { fontSize: '0.85rem' },
                      sx: { height: 40 }
                    }}
                    InputLabelProps={{ 
                      style: { fontSize: '0.85rem' } 
                    }}
                    error={!!(suspensionError && (currentSuspension.qtdDiasUteis === undefined || currentSuspension.qtdDiasUteis <= 0))} 
                    margin="dense"
                    size="small"
                  />
                  <FormControl fullWidth required error={!!(suspensionError && !currentSuspension.contract_operation_suspended_id)} margin="dense" size="small">
                      <InputLabel id="suspensao-operacao-label" sx={{ fontSize: '0.85rem' }}>Operação</InputLabel>
                      <Select
                        labelId="suspensao-operacao-label"
                        name="contract_operation_suspended_id"
                        value={currentSuspension.contract_operation_suspended_id || ''}
                        onChange={handleSuspensionSelectChange}
                        label="Operação"
                        sx={{ fontSize: '0.85rem', height: 40 }}
                      >
                        <MenuItem value="" disabled sx={{ fontSize: '0.85rem' }}><em>Selecione...</em></MenuItem>
                        {operationSuspendedOptions.map((op) => (
                          <MenuItem key={op.id} value={op.id} sx={{ fontSize: '0.85rem' }}>
                            {op.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!(suspensionError && !currentSuspension.contract_operation_suspended_id) && 
                        <FormHelperText error sx={{ fontSize: '0.75rem' }}>Campo obrigatório</FormHelperText>}
                  </FormControl>
                  <TextField 
                    name="observacoes" 
                    label="Observações (Opcional)" 
                    value={currentSuspension.observacoes || ''} 
                    onChange={handleSuspensionChange} 
                    fullWidth 
                    multiline 
                    rows={3} 
                    margin="dense"
                    size="small"
                    InputProps={{ 
                      style: { fontSize: '0.85rem' }
                    }}
                    InputLabelProps={{ 
                      style: { fontSize: '0.85rem' } 
                    }}
                  />
                  <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                      <Button onClick={handleCloseSuspensionDrawer} size="small" sx={{ fontSize: '0.75rem' }}>Cancelar</Button>
                      <Button variant="contained" onClick={handleAddSuspension} size="small" sx={{ fontSize: '0.75rem' }}>Adicionar Suspensão</Button>
                  </Stack>
              </Stack>
          </Box>
      </Drawer>

      {/* Usar o novo componente reutilizável */}
      <ConfirmationDialog
        open={isConfirmDialogOpen}
        onClose={handleCancelSave} // Handler para fechar/cancelar
        onConfirm={handleConfirmSave} // Handler para confirmar
        title="Confirmar Alterações"
        contentText="Tem certeza que deseja salvar as alterações neste contrato?"
        isLoading={saving} // Passar estado de loading
        confirmText={saving ? 'Salvando...' : 'Confirmar'} // Mudar texto do botão se estiver salvando
      />

      {/* Snackbar de Sucesso */}
      <SuccessSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={handleSnackbarClose}
      />

      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={6000} 
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setOpenSnackbar(false)} 
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Box>
  );
};

export default ContractFormPage; 